import { Component } from '@angular/core';

@Component({
    selector: 'pp-settings-header',
    templateUrl: './settings-header.component.html',
    styleUrls: ['./settings-header.component.scss'],
    standalone: false
})
export class SettingsHeaderComponent {}
